/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Teachingsubjects_Subject_Geography17Inputs */

const en__field__enum_teachingsubjects_subject_geography17 = /** @type {(inputs: _Field__Enum_Teachingsubjects_Subject_Geography17Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geography`)
};

const de__field__enum_teachingsubjects_subject_geography17 = /** @type {(inputs: _Field__Enum_Teachingsubjects_Subject_Geography17Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erdkunde / Geographie`)
};

/**
* | output |
* | --- |
* | "Geography" |
*
* @param {_Field__Enum_Teachingsubjects_Subject_Geography17Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_teachingsubjects_subject_geography17 = /** @type {((inputs?: _Field__Enum_Teachingsubjects_Subject_Geography17Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Teachingsubjects_Subject_Geography17Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_teachingsubjects_subject_geography17(inputs)
	return de__field__enum_teachingsubjects_subject_geography17(inputs)
});
export { _field__enum_teachingsubjects_subject_geography17 as "_field__enum_teachingSubjects_SUBJECT_GEOGRAPHY" }